import { FaCode, FaPaintBrush, FaPenFancy, FaPhotoVideo } from "react-icons/fa";
import { MdAnimation } from "react-icons/md";
import { GiPoliceBadge } from "react-icons/gi";

const categories = {
    "Editing": FaPhotoVideo,
    "Management": GiPoliceBadge,
    "Artistry": FaPaintBrush,
    "Design": FaPenFancy,
    "Development": FaCode,
    "Animation": MdAnimation
}

const categoryColours = {
    "Red": {
        "background": {
            name: "bg-red-500",
            hex: "#ef4444",
        },
        dark: false
    },
    "Orange": {
        "background": {
            name: "bg-orange-500",
            hex: "#f97316"
        },
        dark: true
    },
    "Yellow": {
        "background": {
            name: "bg-yellow-500",
            hex: "#eab308"
        },
        dark: true
    },
    "Amber": {
        "background": {
            name: "bg-amber-500",
            hex: "#f59e0b"
        },
        dark: true
    },
    "Blue": {
        "background": {
            name: "bg-blue-600",
            hex: "#2563eb"
        }
    },
    "Cyan": {
        "background": {
            name: "bg-cyan-500",
            hex: "#06b6d4"
        },
        dark: true
    },
    "Teal": {
        "background": {
            name: "bg-teal-500",
            hex: "#14b8a6"
        },
        dark: true
    },
    "Green": {
        "background": {
            name: "bg-green-500",
            hex: "#22c55e"
        },
        dark: true
    },
    "Emerald": {
        "background": {
            name: "bg-emerald-500",
            hex: "#10b981"
        },
        dark: true
    },
    "Indigo": {
        "background": {
            name: "bg-indigo-500",
            hex: "#6366f1"
        },
        dark: false
    },
    "Purple": {
        "background": {
            name: "bg-purple-500",
            hex: "#a855f7"
        },
        dark: false
    },
    "Fuchsia": {
        "background": {
            name: "bg-fuchsia-500",
            hex: "#d946ef"
        },
        dark: false
    }
};

export default categories;
export { categoryColours };